import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import DocumentaryGroupDocumentsCreateModal from '../../../components/dossiers/common/documentaryManagement/DocumentaryGroupDocumentsCreateModal'
import { groupDocuments } from '../../../actions/dossier/common/documentManagementGroupModal'
import {
  refreshDocumentManagementModal
} from '../../../actions/dossier/common/documentManagementModal'

export function mapStateToProps (state, ownProps) {
  return {
    ...state.documentaryGroupDocumentsCreateModalPage,
    ...ownProps
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      groupDocuments,
      refreshDocumentManagementModal
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(DocumentaryGroupDocumentsCreateModal))
